import styled from 'styled-components';

export const FormPanel = styled.div`
  background: #fff;
  padding: 1rem;
`;
